/*
 * Copyright © 2017-2026 Knowledge for Decisions (K4D). All rights reserved.
 *
 * This code and associated materials are protected by copyright laws and
 * international treaties. Unauthorized use, reproduction, distribution, or
 * modification of any content from Knowledge for Decisions (K4D) is strictly
 * prohibited. For inquiries regarding the use or licensing of K4D's
 * copyrighted materials, please contact us at contact@k4d.com.br. "Knowledge
 * for Decisions (K4D)" and the slogan "Using data to make precise decisions"
 * are registered trademarks of Knowledge for Decisions (K4D).
 */

import { useTranslation } from 'react-i18next';
import { Anchor, Text } from '@/shared/ui';
import { META_COMMERCIAL_TERMS_URL, META_LEAD_ADS_TERMS_URL } from '@/shared/utils/ad-dialog-helpers';

const LINK_CLASS = 'font-semibold text-[var(--seed-base)] underline';

/**
 * Links to the Meta terms a user accepts to advertise through their ad
 * account: the Commercial Terms and the Lead Ads Terms. Shown wherever the
 * user authorizes Housien to spend on their behalf.
 */
export function MetaAdsTermsLinks() {
  const { t } = useTranslation('features/properties');
  return (
    <Text variant="small" className="m-0 flex flex-wrap gap-x-(--space-3) gap-y-(--space-1)" data-testid="meta-ads-terms-links">
      <Anchor
        href={META_COMMERCIAL_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASS}
        data-testid="meta-commercial-terms-link"
      >
        {t('adDialogs.spendConfirm.commercialTermsLink')}
      </Anchor>
      <Anchor
        href={META_LEAD_ADS_TERMS_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={LINK_CLASS}
        data-testid="meta-lead-ads-terms-link"
      >
        {t('adDialogs.spendConfirm.leadAdsTermsLink')}
      </Anchor>
    </Text>
  );
}
